<template>
    <mf-modal small :scrollable="true" v-if="isOpen" @close="close">
        <div slot="header">
            {{ headerText }}
        </div>
        <div class="info">
            <div class="info__position" v-if="!event.isSimulatedTime">
                <template v-if="event.at"> At: {{ event.at.name || 'Missing Data' }} </template>
                <template v-else>
                    <div>From: {{ (event.from && event.from.name) || 'Missing Data' }}</div>
                    <div>To: {{ (event.to && event.to.name) || 'Missing Data' }}</div>
                </template>
            </div>
            <mf-divider />
            <template v-if="statementsGroupByType">
                <div v-for="statementsGroupKey in Object.keys(statementsGroupByType)" :key="statementsGroupKey">
                    <div class="info__statement-name">
                        {{ statementsGroupKey }}
                    </div>
                    <div v-for="statement in statementsGroupByType[statementsGroupKey]" :key="statement.id">
                        <div class="info__line">
                            <div class="info__item">
                                Time statement
                            </div>
                            <div class="info__item">
                                <statement-icon class="info__icon" :type="statement.timeType" size="small" />
                                {{ statement.time | dateFilter('date, time') }}
                            </div>
                        </div>
                        <div class="info__line">
                            <div class="info__item">
                                Reported By
                            </div>
                            <div class="info__item">
                                {{ statement.reportedBy }}
                            </div>
                        </div>
                        <div class="info__line">
                            <div class="info__item">
                                Reported at
                            </div>
                            <div class="info__item">
                                {{ statement.reportedAt | dateFilter('date, time') }}
                            </div>
                        </div>
                        <div v-if="statement.isWithdrawn" class="info__item_withdrawn">
                            withdrawn
                        </div>
                        <mf-divider></mf-divider>
                    </div>
                </div>
            </template>
            <div class="info__line" v-else>
                No statements
            </div>
        </div>
        <div slot="footer" v-if="event.isSimulatedTime || isAbleToShowQuay">
            <div class="info__buttons">
                <mf-button v-if="event.isSimulatedTime" color="blue" @click="goToPortcall"> Go to Portcall </mf-button>
                <mf-button v-else color="blue" @click="goToQuay"> Go to Quay </mf-button>
            </div>
        </div>
    </mf-modal>
</template>

<script>
    import StatementIcon from '@/components/statement-components/StatementIcon';

    export default {
        name: 'EventModal',
        components: { StatementIcon },
        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
            event: {
                type: Object,
                required: true,
            },
        },
        computed: {
            statementsGroupByType() {
                return (
                    this.event.statements &&
                    this.event.statements.reduce((result, statement) => {
                        !result[statement.stateDefinition] && (result[statement.stateDefinition] = []);
                        result[statement.stateDefinition].push(statement);
                        return result;
                    }, {})
                );
            },
            isAbleToShowQuay() {
                return this.event.definitionId === 'BERTH_VISIT';
            },
            headerText() {
                return this.event.isSimulatedTime
                    ? `${this.event.at.shortName} - Berth Visit`
                    : this.event.definitionId.split('_').join(' ');
            },
        },
        methods: {
            close() {
                this.$emit('close');
            },
            goToQuay() {
                this.$router.push({ name: 'quay', params: { id: this.event.at } });
            },
            goToPortcall() {
                this.$router.push({ name: 'portcall', params: { id: this.event.portCallId } });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .info {
        display: flex;
        flex-direction: column;
        padding-right: $space-8;
    }

    .info__position {
        font-size: $font-16;
        line-height: $font-24;
        color: $white;
        margin-bottom: $space-6;
    }

    .info__statement-name {
        padding: $space-8;
        background: $marine-600;
        border-radius: 6px;
        font-weight: bold;
        font-size: $font-16;
        line-height: $font-24;
        color: $white;
        margin-top: $space-16;
    }

    .info__line {
        display: flex;
        font-size: $font-14;
        line-height: $font-14;
        color: $white;
        margin: $space-20 0;
    }

    .info__item {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .info__icon {
        margin-right: $space-6;
    }

    .info__buttons {
        display: flex;
        justify-content: flex-end;
    }

    .info__item_withdrawn {
        color: $red-500;
        margin: $space-20 0;
    }
</style>
